import React, {useState} from 'react';
import {HeaderPortal} from '@rocket-ui/components';
import type {FetchVacancyResponse} from '@rocket-ui/lk-api';
import {shouldShowOfferAutoApplyCheckbox} from 'features/offers/model/offerAutoApply';
import {Button} from 'ui';
import styles from '../OfferPage.module.css';

interface OfferHeaderActionsProps {
	vacancy: FetchVacancyResponse;
	isApplying: boolean;
	onApply: (options?: {skipAutoApply?: boolean}) => void;
}

export function OfferHeaderActions({vacancy, isApplying, onApply}: OfferHeaderActionsProps): React.ReactElement | null {
	const [skipAutoApply, setSkipAutoApply] = useState(false);
	const showAutoApplyCheckbox = shouldShowOfferAutoApplyCheckbox(vacancy);

	if (vacancy.applied || vacancy.id == null) return null;

	return (
		<HeaderPortal position="right">
			<div className={`${styles.actions} ${styles.actionsHeader}`}>
				{showAutoApplyCheckbox && (
					<label className={styles.autoApplyLabel}>
						<span>Не хочу откликаться автоматически</span>
						<span className={styles.autoApplyCheckboxWrap}>
							<input
								type="checkbox"
								className={styles.autoApplyCheckbox}
								checked={skipAutoApply}
								onChange={(event) => setSkipAutoApply(event.target.checked)}
							/>
							<span className={styles.autoApplyCheckboxBox} aria-hidden="true" />
						</span>
					</label>
				)}
				<Button
					type="button"
					className={styles.applyButton}
					disabled={isApplying}
					onClick={() => onApply({skipAutoApply: showAutoApplyCheckbox ? skipAutoApply : false})}
				>
					Откликнуться
				</Button>
			</div>
		</HeaderPortal>
	);
}
